import { render, staticRenderFns } from "./mainDataAddr.vue?vue&type=template&id=4b5d311e&scoped=true"
import script from "./mainDataAddr.vue?vue&type=script&lang=js"
export * from "./mainDataAddr.vue?vue&type=script&lang=js"
import style0 from "./mainDataAddr.vue?vue&type=style&index=0&id=4b5d311e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5d311e",
  null
  
)

export default component.exports